import styled from '@emotion/styled';
import { Css } from '../../../../ui';
import Responsive from '../../../../ui/utils/Responsive';
import { Color } from '../../../shared/styles/Color';
import { markdownListStyles } from './markdownListStyles';

export const StyledMarkdownWrapper = styled.div`
	a {
		text-decoration: underline;
		color: ${Color.PrimaryDefault};
		font-weight: bold;

		&:hover {
			outline: 0;
			color: ${Color.TextWhite};
			background-color: ${Color.PrimaryDefault};
			padding: ${Css.pxToRem(2)} ${Css.pxToRem(8)};
		}

		&:focus-visible {
			color: ${Color.TextWhite};
			background-color: ${Color.PrimaryDefault};
			outline: solid 2px ${Color.Highlight};
			border-radius: 4px;
			outline-offset: -2px;
			padding: ${Css.pxToRem(2)} ${Css.pxToRem(8)};
		}
	}
	table {
		width: 100%;
		border-collapse: collapse;
		margin: ${Css.pxToRem(24)} 0;

		@media (${Responsive.getMediaQueryForBreakpoint('mobileXL')}) {
			display: block;
			overflow-x: auto;
		}
	}
	th,
	td {
		border: 1px solid ${Color.TableCellGrey};
		padding: ${Css.pxToRem(12)};
		text-align: left;
		vertical-align: top;
	}

	thead {
		background-color: ${Color.TableHeaderGrey};
		font-weight: bold;
	}

	${markdownListStyles}
`;
